gsap.set('.tour-info-content', { y: '100%' });

const blocks = document.querySelectorAll('.tour-info-block');

blocks.forEach(block => {
    const content = block.querySelector('.tour-info-content');
    const cue = block.querySelector('.tour-cue');

    const tl = gsap.timeline({ paused: true });
    tl.to(content, { y: '0%', duration: 0.4, ease: 'power2.out' }, 0)
        .to(cue, { rotation: 45, duration: 0.3 }, 0)
        .to(block, { backgroundColor: '#2d3648', duration: 0.3 }, 0);

    block.timeline = tl;

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) {
        block.addEventListener('click', () => {
            const isOpen = block.classList.contains('active');

            blocks.forEach(b => {
                if (b !== block) {
                    b.classList.remove('active');
                    b.timeline.reverse();
                }
            });

            if (!isOpen) {
                block.classList.add('active');
                block.timeline.play();
            } else {
                block.classList.remove('active');
                block.timeline.reverse();
            }
        });
    } else {
        let timeout;

        block.addEventListener('mouseenter', () => {
            clearTimeout(timeout);
            block.classList.add('active');
            tl.play();
        });

        block.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
                block.classList.remove('active');
                tl.reverse();
            }, 500); // delay of 1 second before hiding
        });
    }
});

function syncTourCardHeights() {
    const blocks = document.querySelectorAll('.tour-info-block');
    const contents = document.querySelectorAll('.tour-info-content');

    let tallestContent = 0;

    contents.forEach(el => {
        el.style.height = 'auto'; // reset height
        const h = el.scrollHeight;
        if (h > tallestContent) tallestContent = h;
    });

    // Adjust all blocks based on tallest content + extra fixed height for icons/labels
    let extraHeight;
    if (window.matchMedia('(max-width: 600px)').matches) {
        extraHeight = -10; // Mobile small (phones)
    } else if (window.matchMedia('(max-width: 1080px)').matches) {
        extraHeight = -20; // Mobile medium (tablets/small screens)
    } else {
        extraHeight = -43; // Desktop
    }
    const newBlockHeight = tallestContent + extraHeight;

    contents.forEach(el => {
        el.style.height = `${tallestContent}px`;
    });

    blocks.forEach(block => {
        block.style.height = `${newBlockHeight}px`;
    });
}

window.addEventListener('load', syncTourCardHeights);
window.addEventListener('resize', syncTourCardHeights);

document.addEventListener('DOMContentLoaded', () => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) {
        document.querySelectorAll('.tour-info-tip-text').forEach(el => {
            el.textContent = el.textContent.replace('Hover', 'Tap');
        });
    }
});
